<template>
    <div class="edc-business" @click="goToDetails()">
        <div class="edc-business__bk">
            <img :src="image" >
            <div class="edc-business__stars" v-show="stars > 0">
                <EDCStars
                :quantity="`${stars}`"
                :star_size="20"
                golden
                />
            </div>
        </div>
        <div class="edc-business__info">
            <p class="edc-business__info-type">{{ getType(type) }}</p>
            <p class="edc-business__info-title">{{ name }}</p>
        </div>
    </div>
</template>

<script>
import EDCStars from '../components/Stars.vue';

export default {
    name: "edc-business",
    components: {
        EDCStars
    },
    props: {
        id: {
            type: Number,
            required: true
        },
        type: {
            type: String,
            required: true,
            validator(value) {
                return ['RES', 'HOS', 'TOU', 'TRA'].includes(value)
            }
        },
        stars: {
            type: Number,
            min: 0,
            max: 5,
            required: true
        },
        image: {
            type: String,
            required: true,
            default: "https://picsum.photos/800/800?random=1930"
        },
        name: {
            type: String,
            required: true,
            default: 'Nombre de la experiencia'
        }
    },
    methods: {
        getType(type) {
            const types = {
                RES: 'Restaurante',
                HOS: 'Estadía',
                TOU: 'Tour',
                TRA: 'Transporte'
            }

            return types[type]
        },
        getStars() {
            const arr = []

            for (let i = 1; i <= 5; i++) {
                if (i <= this.stars) {
                    arr.push('active')
                } else {
                    arr.push('')
                }
            }

            return arr;
        },
        goToDetails() {
            this.$router.push({ name: 'business-details', params: { id: this.id } })
        }
    }
}
</script>

<style>
/* Card alineada con tarjetas featured moradas (ficha de negocio) */
.edc-business {
    width: 100%;
    height: 240px;
    position: relative;
    border-radius: 16px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    cursor: pointer;
    border: 1px solid rgba(161, 83, 170, 0.22);
    box-shadow:
        0 4px 22px rgba(161, 83, 170, 0.1),
        0 2px 12px rgba(0, 0, 0, 0.05);
    background-color: #fff;
    transition:
        border-color 0.2s ease,
        box-shadow 0.2s ease,
        transform 0.2s ease;
}

.edc-business::before {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 4px;
    border-radius: 0 0 16px 16px;
    background: linear-gradient(
        90deg,
        var(--color-primary, #a153aa) 0%,
        rgba(200, 130, 205, 0.85) 45%,
        rgba(161, 83, 170, 0.35) 100%
    );
    pointer-events: none;
    z-index: 3;
}

.edc-business:hover {
    border-color: rgba(161, 83, 170, 0.42);
    box-shadow:
        0 12px 32px rgba(161, 83, 170, 0.2),
        0 4px 14px rgba(0, 0, 0, 0.08);
    transform: translateY(-3px);
}

.edc-business__bk {
    width: 100%;
    height: 150px;
    min-height: 150px;
    position: relative;
    z-index: 0;
    background: linear-gradient(145deg, #ece8ee 0%, #f5f0f7 100%);
}

.edc-business__bk::before {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 120px;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0%, #000 100%);
}

.edc-business__bk img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.edc-business__stars {
    position: absolute;
    left: 12px;
    bottom: 12px;
    display: flex;
    gap: 4px;
}

.edc-business__info {
    height: 100%;
    width: 100%;
    padding: 14px 18px;
    position: relative;
    z-index: 1;
    display: flex;
    flex-direction: column;
    border-radius: 0 0 16px 16px;
    overflow: hidden;
    background: #fff;
}

.edc-business__info::after {
    content: '';
    position: absolute;
    bottom: -32px;
    right: -24px;
    width: 110px;
    height: 110px;
    border-radius: 50%;
    pointer-events: none;
    opacity: 0.5;
    background: radial-gradient(
        circle at center,
        rgba(161, 83, 170, 0.12) 0%,
        rgba(161, 83, 170, 0.04) 45%,
        transparent 70%
    );
}

.edc-business__info-title {
    height: 100%;
    font-weight: bold;
    font-size: 1.2rem;
    line-height: 120%;
    overflow: hidden;
    position: relative;
    z-index: 1;
    color: var(--color-dark, #222);
}

.edc-business__info-type {
    position: relative;
    z-index: 1;
    font-weight: 600;
    font-size: 0.9rem;
    color: var(--color-primary, #a153aa);
}
</style>